// extracted by mini-css-extract-plugin
export default {"block":"Bubble_block__TzTB2","primary":"Bubble_primary__DJbv6","success":"Bubble_success__1kJsN"};